export default __webpack_public_path__ + "static/media/generatorthumb.486a9556.png";